import { enhancedApi } from '.'

/**
 * Ticket and task writes touch both the standalone-ticket and the project-task caches (a ticket is a task
 * in the organization's catch-all project), status changes append activity events, setting
 * `delegatedAgentId` opens or ends an agent session, and a prompt that reopens an ended session sets
 * `delegatedAgentId` back, so the generated single-tag invalidation is widened here.
 */
enhancedApi.enhanceEndpoints({
  endpoints: {
    updateTaskStatus: {
      invalidatesTags: ['Tasks', 'Tickets', 'Task Activity Events']
    },
    updateTask: {
      invalidatesTags: ['Tasks', 'Tickets', 'Task Activity Events', 'Agent Sessions']
    },
    updateTicket: {
      invalidatesTags: ['Tickets', 'Tasks', 'Task Activity Events', 'Agent Sessions']
    },
    deleteTicket: {
      invalidatesTags: ['Tickets', 'Tasks', 'Agent Sessions']
    },
    deleteTask: {
      invalidatesTags: ['Tasks', 'Tickets', 'Agent Sessions']
    },
    createTicketAgentSession: {
      invalidatesTags: ['Agent Sessions', 'Tickets', 'Tasks', 'Task Activity Events']
    },
    createAgentPrompt: {
      invalidatesTags: ['Agent Sessions', 'Tickets', 'Tasks']
    }
  }
})
